<template>
  <div class="min-h-screen relative bg-black text-white grid md:grid-cols-2">
    <!-- Imagem lateral no desktop -->
    <div class="hidden md:flex items-center justify-center relative">
      <img
        src="/cashbroker-bg.png"
        alt="Cash Broker Background"
        class="absolute inset-0 w-full h-full object-cover"
      />
      <div class="z-10 text-center">
        <h1 class="text-8xl font-bold text-white drop-shadow-lg">Cash</h1>
        <h2
          class="text-4xl font-semibold text-orange-500 tracking-widest mt-2 drop-shadow-lg"
        >
          BROKER
        </h2>
      </div>
    </div>

    <div class="fixed inset-0 z-0 md:hidden">
      <img
        src="/cashbroker-bg.png"
        alt="Cash Broker Background Mobile"
        class="w-full h-full object-cover"
      />
    </div>

    <!-- Card de verificação -->
    <div
      class="flex items-center justify-center p-6 md:bg-[#0f0f0f] relative z-10"
    >
      <div
        class="w-full max-w-md bg-[#1a1a1a] border border-gray-700 p-8 rounded-xl shadow-md"
      >
        <!-- Logo -->
        <div class="flex items-center justify-center gap-4 mb-8">
          <img src="/image/logo.png" alt="Logo" class="h-16 w-auto" />
          <div class="leading-tight">
            <h1 class="text-white text-3xl font-bold">Cash</h1>
            <h2 class="text-orange-500 text-xl font-semibold tracking-widest">
              BROKER
            </h2>
          </div>
        </div>

        <!-- Título -->
        <h2 class="text-white text-xl font-semibold text-center mb-6">
          Verifique seu código
        </h2>

        <!-- Formulário -->
        <form class="space-y-4" @submit.prevent="handleVerify">
          <div>
            <label class="text-sm text-gray-300 block mb-1"
              >Código recebido por e-mail</label
            >
            <input
              v-model="code"
              type="text"
              maxlength="6"
              placeholder="Ex: 123456"
              class="w-full px-4 py-3 rounded-md bg-black/60 text-white placeholder-gray-500 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
          </div>

          <button
            type="submit"
            class="w-full py-3 mt-2 rounded-md bg-gradient-to-r from-orange-600 to-red-600 hover:opacity-90 transition font-semibold"
          >
            <span v-if="isLoading">Verificando...</span>
            <span v-else>Confirmar código</span>
          </button>

          <p v-if="error" class="text-red-400 text-sm text-center mt-2">
            {{ error }}
          </p>
        </form>

        <!-- Voltar -->
        <div class="text-center mt-6">
          <RouterLink
            to="/auth/forgot"
            class="text-sm text-gray-400 hover:text-orange-400 transition"
          >
            Voltar
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const email = (route.query.email as string) || "";
const code = ref("");
const isLoading = ref(false);
const error = ref("");

const handleVerify = async () => {
  if (!code.value) {
    error.value = "Digite o código recebido.";
    return;
  }

  isLoading.value = true;
  error.value = "";

  try {
    // await axios.post("/api/password/verify-code", {
    //   email,
    //   code: code.value,
    // });

    router.push({
      path: "/auth/reset-password",
      query: { email, code: code.value },
    });
  } catch (err: any) {
    error.value = err.response?.data?.message || "Código inválido ou expirado.";
  } finally {
    isLoading.value = false;
  }
};
</script>
